// extracted by mini-css-extract-plugin
module.exports = {"circle":"Input-module--circle--1ulhF","readOnly":"Input-module--read-only--2SEup"};